import React from "react";
import { motion } from "framer-motion";

function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" ? window.innerWidth <= 600 : false
  );

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

function Hero() {
  const isMobile = useIsMobile();

  // Définir les variantes pour l'animation du texte
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  // Styles dynamiques pour la section et le contenu
  const sectionStyle = {
    position: "relative",
    height: isMobile ? "38vh" : "63vh",
    overflow: "hidden",
  };

  const h1Style = {
    fontFamily: "Lato, sans-serif",
    fontWeight: 600,
    fontSize: isMobile ? "2.2rem" : "80px",
    lineHeight: 1.3,
    marginBottom: 0, // aucune marge sous le h1
    marginTop: 3,
  };

  const pStyle = {
    marginTop: 0, // aucune marge au-dessus du p
    fontSize: isMobile ? "1rem" : "24px",
    lineHeight: 1.5,
    marginBottom: "32px",
  };

  const buttonStyle = {
    display: "inline-block",
    padding: "12px 24px",
    backgroundColor: "#fff",
    color: "#0d141a",
    borderRadius: "28px",
    fontSize: "16px",
    fontWeight: 500,
    textDecoration: "none",
  };

  return (
    <section
      id="zLjp5w"
      style={sectionStyle}
      className="hero-section"
    >
      {/* Conteneur de la vidéo */}
      <div
        style={{
          position: "fixed", // <-- remis en "fixed"
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          zIndex: -100,
        }}
      >
        <video
          src="https://videos.pexels.com/video-files/9100625/9100625-uhd_3840_2160_30fps.mp4"
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        ></video>
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
          }}
        ></div>
      </div>

      {/* Contenu centré */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          height: "100%",
        }}
      >
        <motion.h1
          style={h1Style}
          initial="hidden"
          animate="visible"
          variants={textVariants}
          transition={{
            duration: 0.8,
            ease: [0.25, 0.1, 0.25, 1],
          }}
        >
          <strong>NAJDI OUD</strong>
        </motion.h1>
        <p style={pStyle}>
          Découvrez notre sélection de parfums émiratis et saoudiens.
        </p>
        <motion.p
          initial="hidden"
          animate="visible"
          variants={textVariants}
          transition={{
            duration: 0.8,
            ease: [0.25, 0.1, 0.25, 1],
          }}
        >
          <a href="./parfums" style={buttonStyle}>
            Explorer
          </a>
        </motion.p>
      </div>
    </section>
  );
}

export default Hero;